import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGrid, FiUsers } = FiIcons;

const AdminNav = ({ currentView, setCurrentView }) => {
  const { isDark } = useTheme();

  const navItems = [
    { id: 'admin-dashboard', label: 'Segnalazioni', icon: FiGrid },
    { id: 'admin-users', label: 'Utenti', icon: FiUsers }
  ];

  return (
    <nav className={`${
      isDark ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'
    } border-b shadow-sm`}>
      <div className="container mx-auto px-4">
        <div className="flex space-x-1">
          {navItems.map(item => (
            <button
              key={item.id}
              onClick={() => setCurrentView(item.id)}
              className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors ${
                currentView === item.id
                  ? isDark
                    ? 'text-blue-400 border-blue-400 bg-gray-700'
                    : 'text-blue-600 border-blue-600 bg-blue-50'
                  : isDark
                    ? 'text-gray-300 border-transparent hover:text-blue-400 hover:bg-gray-700'
                    : 'text-gray-500 border-transparent hover:text-blue-600 hover:bg-gray-50'
              }`}
            >
              <SafeIcon icon={item.icon} className="w-4 h-4" />
              <span>{item.label}</span>
            </button>
          ))}
        </div>
      </div>
    </nav>
  );
};

export default AdminNav;